import logger from '@/modules/Logger';

/**
 * Class handler for our decision to use the NEW CHAT HISTORY page from `mystage-frontend` & `mystage-backend` or the OLD one from `bizmates.jp`
 * @TODO Experimental flagging of feature, so we wont need to reiterate user based and beta-level dataa checking
 */
export const IfUseNewChatHistoryState = {
  msb: () => {
    logger.info(`[IfUseNewChatHistoryState] Use the new chat history page from MyStage`, {
      operation: 'state:chat-history-feature'
    });

    return true;
  },

  legacy: () => {
    logger.info(`[IfUseNewChatHistoryState] Use the OLD / legacy chat history page from bizmates.jp`, {
      operation: 'state:chat-history-feature'
    });

    return false;
  }
};
